import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { Translate, ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './log.reducer';
import { ILog } from 'app/shared/model/log.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface ILogDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export class LogDetail extends React.Component<ILogDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { logEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            <Translate contentKey="dealorGatewayApp.log.detail.title">Log</Translate> [<b>{logEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="action">
                <Translate contentKey="dealorGatewayApp.log.action">Action</Translate>
              </span>
            </dt>
            <dd>{logEntity.action}</dd>
            <dt>
              <span id="details">
                <Translate contentKey="dealorGatewayApp.log.details">Details</Translate>
              </span>
            </dt>
            <dd>{logEntity.details}</dd>
            <dt>
              <span id="timestamp">
                <Translate contentKey="dealorGatewayApp.log.timestamp">Timestamp</Translate>
              </span>
            </dt>
            <dd>
              <TextFormat value={logEntity.timestamp} type="date" format={APP_DATE_FORMAT} />
            </dd>
          </dl>
          <Button tag={Link} to="/entity/log" replace color="info">
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ log }: IRootState) => ({
  logEntity: log.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogDetail);
